/*
 * The tags wrap onto as many lines as they need: a phone at 320 px never scrolls sideways, and a
 * long tag breaks inside its chip rather than pushing the page wider.
 */
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  max-width: 100%;
  min-width: 0;
  padding: 0.125rem 0.125rem 0.125rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  background-color: var(--surface-sunken);
  font-size: 0.875rem;
}

.text {
  min-width: 0;
  overflow-wrap: anywhere;
}

.none {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.875rem;
}
